import { Inverse } from "./Inverse.js"

/**
 * @description
 *	Utility functions for enumerated types.
 */
export default class Enum {
	private constructor() {
		throw new Error("Shall not instantiate this class.")
	}

	public static inverse<T extends number | string | symbol>(record: Record<string, T>): Inverse<Record<string, T>> {
		const entries = Object.entries(record).map(([key, value]) => [value, key])
		return Object.fromEntries(entries) as Inverse<Record<string, T>>
	}
}
